// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + "index" + "." + "4c195a9a02487180b636" + ".css";
};